import { useQuery, useMutation } from "@tanstack/react-query";
import {
  checkAdmin,
  checkAuth,
  passwordResetRequest,
  passwordResetSubmit,
  loginAsAdmin,
} from "../Api/auth";
import { login } from "../Api/auth";

export const usePasswordResetRequest = () => {
  return useMutation({
    mutationFn: (email: string) => passwordResetRequest(email),
  });
};

export const usePasswordResetSubmit = () => {
  return useMutation({
    mutationFn: ({
      password,
      token,
    }: {
      password: string;
      token: string | null;
    }) => passwordResetSubmit(password, token),
  });
};

export const useLogin = () => {
  return useMutation({
    mutationFn: ({
      username,
      password,
    }: {
      username: string;
      password: string;
    }) => login(username, password),
  });
};

export const useCheckAuth = ({ enabled }: { enabled: boolean }) => {
  return useQuery({
    queryKey: ["checkAuth"],
    queryFn: checkAuth,
    enabled,
  });
};

export const useCheckAdmin = ({ enabled }: { enabled: boolean }) => {
  return useQuery({
    queryKey: ["checkAdmin"],
    queryFn: checkAdmin,
    enabled,
  });
};

export const useLoginAsAdmin = () => {
  return useMutation({
    mutationFn: (user_id: string) => loginAsAdmin(user_id),
  });
};
